import { Component } from '@angular/core';

@Component({
  selector: 'app-scatter-chart-custom',
  template: '<app-chart-output></app-chart-output>',
})
export class ScatterChartComponentCustom {

}
